module.exports = __webpack_public_path__ + "static/media/lato-v15-latin-regular.b4d2c4c3.woff2";